import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Container from '../components/container'
import Breadcrumb from '../components/breadcrumb'
import SearchBar from '../components/search-bar'
import RelatedPages from '../components/related-pages'
import BlogPostPreviewList from '../components/blog-post-preview-list'
import DynamicZoneComponent from '../components/dynamic-zone-component'
import Markdown from "react-markdown";
import ArticleHeader from "../components/article-header-infinite"
import ArticleFooter from "../components/article-footer-infinite"
import OfferAffiliateNotice from "../components/offer-affiliatenotice"

import * as styles from './blog-post-infinite.module.css'


function string_to_slug(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap ñ for n, etc
    var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaaeeeeiiiioooouuuunc------";

    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

function BlogPostInfinite ({article, search_index}) {
  const image = getImage(article?.main_image?.imageFile)

  var is_affiliate = []
  // loop through data and determine if there are affiliate offers
  // check list for offers
  if(article.body){
      for(let i = 0; i < article.body.length; i++){
          for(let j = 0; j < article.body[i].offers.length; j++){
            is_affiliate.push(true)
          }
      }
  }

  // devine section numbers if more than one
  var sectionNumber = 0

  return (
    <>
        <ArticleHeader article={article}></ArticleHeader>
        {
        // main image if no children
        article.main_image && article.children && article.children.length === 0 &&
        <div className={styles.hero}>
            <GatsbyImage image={image} alt={article.main_image.alternativeText ? article.main_image.alternativeText : "a nice image" } />
            {article.main_image.caption}
        </div>
        }
        <Container>
            <Markdown children={article.body_introduction} skipHtml={true} />
            
            {
                // display body components table of contents
                article.body && article.body.length > 1 &&
                    <>
                        <ol>
                        { article.body.map(component => component && (
                            <li key={"shortcut_"+component._id}>
                                <a href={"#"+string_to_slug(component.title)}>{component.title}</a>
                            </li>
                        ))
                        }
                        </ol>
                    </>
            }

            {
            // add children posts if any
            article.children && article.children.length > 0 && (
                <BlogPostPreviewList
                    nodes={article.children}
                    max_n="5"
                    page_type={article.page_type}
                />
            )}

            {
                // show affiliate notice
                is_affiliate && is_affiliate.length > 0 &&
                <OfferAffiliateNotice></OfferAffiliateNotice>
            }


            
            {
                // display body components
                article.body && article.body.map(component => {
                    // increment
                    sectionNumber = sectionNumber + 1
                    return (component && 
                        <div key={component._id}>
                            <DynamicZoneComponent component={component} index={sectionNumber+". "} anchor={string_to_slug(component.title)}></DynamicZoneComponent>
                        </div>
                    )
                }
                )
            }
            <Markdown children={article.body_conclution} skipHtml={true} />
            
            <ArticleFooter ></ArticleFooter>
            {search_index &&
                <SearchBar></SearchBar>
            }
            {
                // related pages
                article.related_pages && article.related_pages.length > 0 && (
                <RelatedPages nodes={article.related_pages}></RelatedPages>
            )}
        </Container>
    </>
  )
}

export default BlogPostInfinite
